(function () {
  /**
   * @ngdoc       module
   * @name        binky.core.fraud-mitigation
   * @description Define core fraud-mitigation module
   */

  angular.module('binky.core.fraud-mitigation', ['binky.core.dom-utils', 'binky.core.feature']);
})();
